// removed by extract-text-webpack-plugin
module.exports = {"Base":"TheDrip__Base-1FC7_","Articles":"TheDrip__Articles-3AVk2","Article":"TheDrip__Article-2uS_a","Link":"TheDrip__Link-2snO0","Figure":"TheDrip__Figure-3RLDb","Image":"TheDrip__Image-1112K","Content":"TheDrip__Content-3dvwb","Content--wide":"TheDrip__Content--wide-2oTE0","Header":"TheDrip__Header-2RLgV","Title":"TheDrip__Title-3fu3G","Footer":"TheDrip__Footer-2Ambn","FooterLink":"TheDrip__FooterLink-R-Qyq"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/TheDrip/TheDrip.css
 ** module id = 645
 ** module chunks = 0
 **/